// Util functions used by editor components
export function getEventValue(event) {
    // If native event return target value
    if (event.target) {
        return event.target.value
    }
    return event
}

export function getEventName(subevent, fieldName) {
    return subevent + ':' + fieldName
}

export function transformDate(date, isDateTimeField) {
    if (isDateTimeField) {
        return transformDateTime(date)
    } else {
        return transformISO8601Date(date)
    }
}

export function transformDateTime(date) {
    // Transform date into ISO-8601 with time format
    return new Date(new Date(date.getTime() - (date.getTimezoneOffset() * 60000))).toISOString()
}

export function transformISO8601Date(date) {
    // Transform date into ISO-8601 date format
    return new Date(new Date(date.getTime() - (date.getTimezoneOffset() * 60000))).toISOString().slice(0, 10)
}

export function hasError(id, field, validationErrors) {
    if (!validationErrors || !validationErrors[id]) {
        return false
    }
    let errors = validationErrors[id][field]
    return (Array.isArray(errors) && errors.length > 0)
}

// Return whether an item in a component field has error
export function itemHasError(id, validationErrors) {
    if (!validationErrors || !validationErrors[id]) {
        return false
    }
    for (const ierror of Object.values(validationErrors[id])) {
        if (ierror.length > 0) {
            return true
        }
    }
    return false
}

// Returns the options for fields that have dropdown options
// Also returns the default
export function getFieldChoices(metadata, keys) {
    for (let key of keys) {
        // Get the field specific metadata
        metadata = metadata[key]
    }
    if (metadata['choices'] !== undefined) {
        return {
            choices: metadata['choices'],
            default: metadata['default']
        }
    }
    return {}
}

// Returns the options for Value Meaning fields
export function getVMSet(valuemeaningset) {
    var choices = new Array
    for (let vm of valuemeaningset) {
        if (vm) {
            var n = new Object
            n.internal = vm.id
            n.external = vm.name
            choices.push(n)
        }
    }
    return {choices: choices, default: null}
}

export function isSubComponent(metadata) {
    // TODO: this should be updated when we have a better way to check whether something is a subcomponent
    return metadata.read_only === undefined
}

// Return the "empty" option for the field
function getEmptyFieldOption(fieldMetadata, subfield) {
    if (fieldMetadata.default !== undefined) {
        return fieldMetadata.default
    } else if (fieldMetadata.is_related === true || fieldMetadata.min_value === 0 || fieldMetadata.is_date_time === true) {
        return null
    } else if (subfield === 'linked_group' || subfield === 'specialisation_classes' || subfield === 'lineage_relationships') {
        // initialize array field (multiple value) as an array
        return new Array()
    } else {
        return ''
    }
}

// Return empty object item data for a subitem, empty type needs to be same
export function generateEmptySubItem(metadata, field) {
    const subitem_metadata = metadata[field]
    if (!isSubComponent(subitem_metadata)) {
        // eslint-disable-next-line no-console
        console.error("generateEmptySubItem can only be called with subcomponents")
    } else {
        let subItemData = {}
        for (const [subfield, fieldMetadata] of Object.entries(subitem_metadata)) {
            subItemData[subfield] = getEmptyFieldOption(fieldMetadata, subfield)
        }
        if (field == 'datasetdistributiongroup_set') {
            subItemData['datasetdistributiongroup_set'] = []
            subItemData['datasetdistributionpath_set'] = []
        }

        return subItemData
    }
}

// Scroll to top of the window
export function scrollTop() {
    window.scrollTo(0, 0)
}

// Check two items are same
export function isSame(item1, item2) {
    return JSON.stringify(item1) === JSON.stringify(item2)
}

// Construct a MPTT model data back into tree structure
export function toTree(dataset) {
    const hashTable = Object.create(null);
    dataset.forEach(aData => hashTable[aData.id] = {...aData, data: []});
    const dataTree = [];
    dataset.forEach(aData => {
        if(aData.pid){
            hashTable[aData.pid].data.push(hashTable[aData.id])
        } else {
            dataTree.push(hashTable[aData.id])
        }
    });
    return dataTree;
}

// Flatten tree into array
export function traverse(node, path = [], addPid = false){
    if (!node || !node.data || !node.data.length) {
        path.push(node.id)
    }
    for (const child of node) {
        if (child.id) {
            path.push(addPid ? {id: child.id, pid: child.pid} : child.id)
        }
        if (child.data) {
            traverse(child.data, path, addPid)
        }
    }
    return path.filter(Boolean)
}

// Find parent node from tree
export function findPid(arr, id, parent) {
    var node;

    arr.some(function (n) {
        if (n.data.localId === id) {
            return node = parent;
        }
        if (n.data) {
            return node = findPid(n.children, id, n);
        }
    });
    return node || null;
}

// Find node according to localId
export function getItemFromTree(localId, dataArray) {
    let node
    dataArray.some(function(n) {
        if (n && n.data && n.data.localId === localId) {
            return node = n
        }
        if (n && n.children && n.children.length) {
            return node = getItemFromTree(localId, n.children)
        }
    })
    return node || null
}

export function isStringOrNumber(val) {
    return ['string', 'number'].includes(typeof val)
}
